import { render } from "./Popular-products.vue?vue&type=template&id=61ac3902&scoped=true"
import script from "./Popular-products.vue?vue&type=script&lang=js"
export * from "./Popular-products.vue?vue&type=script&lang=js"

import "./Popular-products.vue?vue&type=style&index=0&id=61ac3902&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ac3902"]])

export default __exports__